import { createStore, createLogger } from 'vuex';

import { store as three, ThreeStore, State as ThreeState } from '@/store/modules/three';
import { store as configuration, ConfigurationStore, State as ConfigurationState } from '@/store/modules/configuration';
import { store as colorpicker, ColorpickerStore, State as ColorpickerState } from '@/store/modules/colorpicker';
import { store as page, PageStore, State as PageState } from '@/store/modules/page';
import { store as form, FormStore, State as FormState } from '@/store/modules/form';
import { store as rendering, RenderingStore, State as RenderingState } from '@/store/modules/rendering';

export type RootState = {
  three: ThreeState;
  configuration: ConfigurationState;
  colorpicker: ColorpickerState;
  page: PageState;
  form: FormState;
  rendering: FormState;
};

export type Store = ThreeStore<Pick<RootState, 'three'>>
  & ConfigurationStore<Pick<RootState, 'configuration'>>
  & ColorpickerStore<Pick<RootState, 'colorpicker'>>
  & PageStore<Pick<RootState, 'page'>>
  & FormStore<Pick<RootState, 'form'>>
  & RenderingStore<Pick<RootState, 'rendering'>>;

// const debug = process.env.NODE_ENV !== 'production';
// const plugins = debug ? [createLogger({ logActions: false, logMutations: true })] : [];
// const plugins = [createLogger({ logActions: true, logMutations: true })];
const plugins = []

export const store = createStore({
  plugins,
  modules: {
    three,
    configuration,
    colorpicker,
    page,
    form,
    rendering
  },
});

export function useStore(): Store {
  return store as Store;
}
